import { ApplianceState } from './types';

const state = (): ApplianceState => {
  return {
    appliances: [],
  };
};

export default state;
